import { Link } from 'react-router-dom'
import Countdown from './Countdown/Countdown'
import ProgressBar from './ProgressBar/ProgressBar'
import { useAdminResource } from '../Passport/adminState'
import classes from './Dashboard.module.css'

export function nearestEvent(events = []) {
    return events.filter(event => Number.isFinite(Date.parse(event.dates?.[0]?.date || event.date)))
        .sort((a,b) => Date.parse(a.dates?.[0]?.date || a.date) - Date.parse(b.dates?.[0]?.date || b.date))[0]
}
const count = value => Math.max(0, Number(value) || 0)
export default function Dashboard({ upcoming = [] }) {
    const event = nearestEvent(upcoming)
    const moderation = useAdminResource('/passport/admin/submissions?status=pending')
    const paid = count(event?.ticketsCount), free = count(event?.freeTicketsCount)
    return <div className={classes.main}>
        <section className={classes.card}>
            <p className={classes.caption}>Найближча подія</p>
            <h3>{event?.title || 'Немає запланованих подій'}</h3>
            {event && <Countdown targetDate={event.dates?.[0]?.date || event.date}/>}
            <Link to="/events" className={classes.link}>Переглянути події →</Link>
        </section>
        {event && <>
            <div className={classes.stats}>
                <Stat label="Платні квитки" value={paid}/>
                <Stat label="Безкоштовні квитки" value={free}/>
                <Stat label="Усього квитків" value={paid + free}/>
                <Stat label="Середня ціна платного квитка" value={`${count(event.averagePrice).toLocaleString('uk-UA')} ₴`}/>
            </div>
            <section className={classes.card}>
                <h3>Прогрес продажів</h3>
                <p className={classes.caption}>Орієнтир: 2 000 квитків. Це ціль продажів, а не місткість локації.</p>
                <ProgressBar mainProgress={paid} subProgress={paid + free} total={2000}/>
            </section>
        </>}
        <section className={classes.card}>
            <h3>Потребує уваги</h3>
            <p className={classes.caption}>{moderation.loading ? 'Завантаження заявок…' : moderation.error ? 'Не вдалося завантажити заявки.' : `Заявки на контент: ${moderation.data?.submissions?.length ?? 0}`}</p>
            <div className={classes.links}>
                <Link to="/passport" className={classes.link}>Модерація та бонуси →</Link>
                <Link to="/tickets" className={classes.link}>Квитки →</Link>
                <Link to="/campaigns" className={classes.link}>Email-розсилки →</Link>
            </div>
        </section>
    </div>
}
function Stat({label,value}) { return <div className={classes.card}><p className={classes.caption}>{label}</p><strong className={classes.value}>{value}</strong></div> }
